import "./homecardsection.css"
import {ContainerComponent} from "../../../app/components/container/ContainerComponent";
import {GridComponent} from "../../../app/components/grid/GridComponent";

export function HomeCardSectionComponent({
                                             children,
                                             title,
                                             description,
                                             homeCardSectionTextPlacement,
                                             highlightBackground
                                         }) {
    return (
        <div className={"homeCardsBackground" + (highlightBackground ? " highlight" : "")}>
            <ContainerComponent className={"homeCardsContent" + homeCardSectionTextPlacement}>
                <div className="textWrapper">
                    <h2>{title}</h2>
                    {description}
                </div>
                <GridComponent className="cardsWrapper">
                    {children}
                </GridComponent>
            </ContainerComponent>
        </div>
    );
}

export const HomeCardSectionTextPlacement = {
    Top: " top",
    End: " end",
    Bottom: " bottom",
    Start: " start",
}
